import React, { memo } from 'react';
import KPIBlock from '../structured/KPIBlock';
import styles from './consultantReport.module.css';

function MetricsGrid({ blocks, renderContext }) {
    if (!blocks?.length) return null;
    return (
        <div className={styles.metricsGridWrap}>
            {blocks.map(block => (
                <KPIBlock key={block.id} block={block} renderContext={renderContext} />
            ))}
        </div>
    );
}

export default memo(MetricsGrid);
